var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import HomeService from '../../api/HomeService';
import SectionMenu from './SectionMenu.vue';
import WarnModal from './warnComponents/WarnModal.vue';
var WARN_ICONS = {
    date_warn: '../../../static/image/date_warn.png',
    date_warn_grey: '../../../static/image/date_warn_grey.png',
    max_stock_warn: '../../../static/image/max_stock_warn.png',
    max_stock_warn_grey: '../../../static/image/max_stock_warn_grey.png',
    unsalable_warn: '../../../static/image/unsalable_warn.png',
    unsalable_warn_grey: '../../../static/image/unsalable_warn_grey.png',
    safe_stock_warn: '../../../static/image/safe_stock_warn.png',
    safe_stock_warn_grey: '../../../static/image/safe_stock_warn_grey.png',
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.warnIcons = WARN_ICONS;
        _this.warningData = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = HomeService.getInstance();
        this.getStockWarning();
    };
    default_1.prototype.showWarnModal = function (type, activeName, warning_id) {
        console.log(this.warningData);
        if (type && !this.warningData[type - 1].status)
            return;
        this.$refs.WarnModal.showWarnModal(type, activeName, warning_id);
    };
    default_1.prototype.refresh = function () {
        this.getStockWarning();
    };
    default_1.prototype.getStockWarning = function () {
        var _this = this;
        this.service
            .getStockWarning()
            .then(function (res) {
            _this.warningData = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "pageAuth", void 0);
    default_1 = __decorate([
        Component({
            components: {
                SectionMenu: SectionMenu,
                WarnModal: WarnModal
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
